<template>
  <!--Look into the functions later-->
  <v-row>
    <v-container>
      <router-view @snackbarevent="updateSnackbar"></router-view>
    </v-container>
  </v-row>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      DialogEditTagProfile: false,
      EditTagProfile: {
        name: "",
        id: null,
        geotags: [],
        maintags: []
      },
      UserArticleHeaders: [
        { text: "Id", value: "id" },
        { text: "Title", value: "Title" },
        { text: "Created", value: "Created" },
        { text: "Updated", value: "Updated" },
        { text: "Published", value: "Published" },
        { text: "MediaId", value: "MediaId" }
      ],
      choices: {
        sex: [
          { text: "Male", value: "M" },
          { text: "Female", value: "F" }
        ],
        language: [
          { text: "Norwegian", value: "NO" },
          { text: "English", value: "EN" }
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "authStatus",
      "getUser",
      "updateStatus",
      "getHistory"
    ])
  },
  watch: {
    updateStatus() {
      switch (this.updateStatus) {
        case "loading":
          this.$emit("snackbarevent", "Please wait while we save the data.");

          break;
        case "error":
          this.$emit(
            "snackbarevent",
            "An error occurred while saving the data."
          );
          break;
        case "success":
          this.$emit("snackbarevent", "Saved successfully");
          break;
        default:
          this.$emit("snackbarevent", this.updateStatus);
      }
    }
  },
  methods: {
    updateSnackbar(message) {
      this.$emit("snackbarevent", message);
    },
    ...mapActions(["updateUser"]),
    submitUserChange() {
      this.getUser.FullName =
        this.getUser.FirstName != "" && this.getUser != ""
          ? [this.getUser.FirstName, this.getUser.LastName].join(" ")
          : this.getUser.Email;
      this.updateUser({ ...this.getUser });
    },
    saveDialogEditProfile() {
      //  let _output = {
      //    id: this.EditTagProfile.id,
      //    name: this.EditTagProfile.name,
      //    userid: this.userData.id,
      //    Tags: this.EditTagProfile.geotags.concat(this.EditTagProfile.maintags)
      //  };
      //  instance.post("/user/tagprofile", _output).then(res => {
      //    this.fetchUser().then(res => {
      //      this.closeDialogEditProfile();
      //    });
      //  });
    },
    DeleteUserTagProfile() {
      //  let _answer = confirm("Are you sure you want to delete this profile?");
      //  if (_answer) {
      //    let _output = {
      //      params: {
      //        id: this.EditTagProfile.id,
      //        delete: true
      //      }
      //    };
      //    instance.delete("/user/tagprofile", _output).then(res => {
      //      this.fetchUser().then(res => {
      //        this.closeDialogEditProfile();
      //      });
      //    }).catch(res => {
      //      alert("This profile is in use, and cant be deleted")
      //    });
      //  }
    },
    closeDialogEditProfile() {
      //  this.EditTagProfile.geotags = [];
      //  this.EditTagProfile.maintags = [];
      //  this.EditTagProfile.name = "";
      //  this.EditTagProfile.id = null;
      //  this.DialogEditTagProfile = false;
    },
    editTagProfile(id) {
      //  if (!isNaN(id)) {
      //    let _EditTagProfile = this.userData.TagProfiles.find(
      //      res => res.id == id
      //    );
      //    this.EditTagProfile.geotags = _EditTagProfile.tags
      //      .filter(res => res.TypeId == 1)
      //      .map(res => res.id);
      //    this.EditTagProfile.maintags = _EditTagProfile.tags
      //      .filter(res => res.TypeId == 2)
      //      .map(res => res.id);
      //    this.EditTagProfile.name = _EditTagProfile.name;
      //    this.EditTagProfile.id = _EditTagProfile.id;
      //  }
      //  this.DialogEditTagProfile = true;
    },
    GoToArticle(id) {
      //  this.$router.push({ path: "/article/" + id });
    },
    //     ...mapActions(["fetchUser", "UserChange", "fetchUserArticles"]),
    updateProfile() {
      //  this.snackbartext = "Saving profile...";
      //  this.snackbar = true;
      //  instance.post("/users", this.userData).then(res => {
      //    instance
      //      .post("/user/get", {
      //        auth: this.userData.AuthId
      //      })
      //      .then(res => {
      //        this.$store.commit("setUser", {
      //          user: res.data
      //        });
      //        this.snackbartext = "Profile saved";
      //        this.snackbar = true;
      //      });
      //  });
    },
    removeGeoTag(item) {
      //  let index = this.EditTagProfile.geotags.indexOf(item.id);
      //  if (index >= 0) this.EditTagProfile.geotags.splice(index, 1);
    },
    removeMainTag(item) {
      //  let index = this.EditTagProfile.maintags.indexOf(item.id);
      //  if (index >= 0) this.EditTagProfile.maintags.splice(index, 1);
    }
  },
  mounted() {
    //     this.fetchUserArticles({
    //       currentUserId: this.userData.id,
    //       AuthorId: this.userData.id
    //     });
    //     this.$store.dispatch("fetchGeoTags");
    //     this.$store.dispatch("fetchMainTags");
  }
};
</script>
